import { Typography } from "@mui/material";
import React from "react";

const Title = ({ text }) => {
  return (
    <Typography
      sx={{
        fontSize: { xs: "11.5px", md: "2.5vw", lg: "16px" },
        lineHeight: { xs: "5vw", sm: "5vw", md: "5vw", lg: "3vw" },
        fontWeight: { xs: "500", sm: "500", md: "500", lg: "900" },
        color: "#33AEA0",
        textAlign: "center",
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: text }}></div>
    </Typography>
  );
};

export default Title;
